import { useEffect } from 'react';
import { useAppStore } from '../../stores/app';

const ExamInProgress = ({ inSession }) => {
  const { getSessionStartData } = useAppStore();
  useEffect(() => {
    const initExamInProgress = async () => {
      try {
        const sessionStartData = await getSessionStartData();
        window.location.href = sessionStartData.examUrl;
      } catch (error) {
        console.error('Failed to load exam:', error);
        // Handle error appropriately - redirect to error page or show message
      }
    };
    if(!inSession){
      initExamInProgress();
    }    
  }, [inSession]);

  return null;
};

export default ExamInProgress;
